import { render, staticRenderFns } from "./NavigatingButton.vue?vue&type=template&id=7b23e26e&"
import script from "./NavigatingButton.vue?vue&type=script&lang=ts&"
export * from "./NavigatingButton.vue?vue&type=script&lang=ts&"
import style0 from "./NavigatingButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports